import { useMemo, useState } from 'react';
import ENABLE from '../../constants/enable';

const PENDING_DENOMINATION = 'Pendiente de Denominación';
const localeDateDataType = {
    numeric: 'numeric',
    '2-digit': '2-digit',
    short: 'short',
};

const dateTimeFormatOptions = {
    year: localeDateDataType.numeric,
    month: localeDateDataType.short,
    day: localeDateDataType['2-digit'],
    timeZone: 'UTC',
};

const getFeeValue = (amount, installment, percentage) => {
    if (amount === 0) return 0;
    return (amount / installment) * percentage;
};

export const useInstallmentsStepOne = (context) => {
    const [selectedValue, setSelectedValue] = useState('');
    const [amountTarget, setAmountTarget] = useState('');

    const idsPlan = useMemo(() => {
        localStorage.setItem('assistance', JSON.stringify(context?.installmentsExtraData.assistanceMapping));
        return context?.installmentsExtraData.idsPlan;
    }, [context.installmentsExtraData]);

    const isAmountValid = (amount) =>
        amount >= context?.amountLimit?.amountMinOfInstallments &&
        amount <= context?.amountLimit?.amountMaxOfInstallments;

    const getLabelFee = (amount, installments) => {
        const installmentAllowed = [];
        for (const iterator of installments) {
            const feeValue = getFeeValue(amount, iterator.installments, iterator.totalCoefficient);
            const moneyValue = feeValue.toLocaleString('es-AR', {
                style: 'currency',
                currency: 'ARS',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            const date = new Date(iterator.firstExpirationDate)
                .toLocaleDateString('es-ES', dateTimeFormatOptions)
                .toLocaleUpperCase();

            installmentAllowed.push({
                ...iterator,
                label: ENABLE?.enableInstallmentsWithDate
                    ? `${iterator.installments} Cuotas de ${moneyValue} Primer Vto.: ${date}`
                    : `${iterator.installments} Cuotas de ${moneyValue}`,
                feeValue,
            });
        }
        return installmentAllowed;
    };

    const handleAmountChange = (value) => {
        setAmountTarget(value);
        if (context?.installment.length) {
            context.setInstallment(getLabelFee(value, context.installment));
        }
    };

    const installmentAllowed = useMemo(() => {
        const data = context?.installment.filter(
            (i) => i.feeValue < context.amountLimit?.installmentAmountMax
        );
        const commercialPlans = ENABLE.enableGetInstallments
            ? context.commercialPlans
            : context.installmentsExtraData.commercialPlans;
        const matchingPlan =
            selectedValue === PENDING_DENOMINATION
                ? 0
                : commercialPlans.filter((item) => item.description === selectedValue);

        let result;
        if (isAmountValid(amountTarget)) {
            if (matchingPlan === 0) {
                const allValues = commercialPlans.flatMap((item) =>
                    item.values.map((value) => value.id)
                );
                result = data.filter(
                    (d) => !allValues.includes(JSON.parse(d.value).idCommercialPlan)
                );
            }
            else {
                const allMatchingValues = matchingPlan.flatMap((item) =>
                    item.values.map((value) => value.id)
                );
                result = data.filter((d) =>
                    allMatchingValues.includes(JSON.parse(d.value).idCommercialPlan)
                );
            }
        }
        return result || [];
        // eslint-disable-next-line
    }, [context.installment, selectedValue, amountTarget]);

    return {
        selectedValue,
        setSelectedValue,
        amountTarget,
        setAmountTarget,
        idsPlan,
        installmentAllowed,
        handleAmountChange,
    };
};
